export const URLs = {
    DEV: "https://gtform.angeronacloud.com.br/api"
};